import styles from './BaseButton.module.css';

type BaseButtonProps = {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  variant?: 'primary' | 'outline';
  type?: 'button' | 'submit' | 'reset';
  href?: string;
};

const BaseButton = ({
  text,
  onClick,
  disabled,
  className,
  variant = 'primary',
  type = 'button',
  href,
}: BaseButtonProps) => {
  const classes = [
    styles.button,
    styles[variant],
    className
  ]
    .filter(Boolean)
    .join(' ');

  if (href) {
    return (
      <a 
        href={href} 
        className={classes}
        onClick={onClick}
        aria-disabled={disabled}
        style={{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }}
      >
        {text}
      </a>
    );
  }

  return (
    <button type={type} className={classes} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
};

export default BaseButton;
